module.exports = __webpack_public_path__ + "assets/01.4272a1b8.pdf";